module.exports = __webpack_public_path__ + "img/LCRG_Swords_01.90e0f458.png";